import { UserAction } from "../actions";
// import { Alert } from "react-native"
import { Functions, ApiCaller, Variables } from "../../config";
import info from "../../components/info";
import { put, delay } from "redux-saga/effects";
import {
  CANCEL_SUBSCRIPTION,
  CHECK_ACCOUNT,
  CREATE_ACCOUNT,
  CREATE_LINK,
  DEACTIVE_USER,
  NOTTIFICATION,
  SUBSCRIPTION,
  UPDATE_PROFILE,
  USER,
} from "../../config/variables";
import AuthAction from "../actions/AuthAction";

const userId = JSON.parse(localStorage.getItem("platform_owner"))?.[2]
  ?.platform_owner_user?.id;

export default class userMiddleWarre {
  static *getUserMiddleWare(action) {
    const { id, params } = action;
    const qureyParams = new URLSearchParams(params).toString();

    const userId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    console.log("usssssssssseerr===>", userId);
    try {
      let res = yield ApiCaller.Get(
        `platform_owners/${userId}/users?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(
          UserAction.getUserSuccess(res.data.data, null, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getUserError());
      }
    } catch (e) {
      yield put(UserAction.getUserError());
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createUserMiddleWare(action) {
    const { payload, cb, params } = action;
    const userId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;

    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    try {
      let res = yield ApiCaller.Post(
        `platform_owners/${userId}/users`,
        formData,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 201) {
        cb() && cb();
        yield put(UserAction.getUserSuccess(res.data.data, null));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createUserError());
      }
    } catch (e) {
      yield put(UserAction.createUserError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getUserDetailMiddleWare(action) {
    const { userId, cb } = action;
    try {
      let res = yield ApiCaller.Get(`platform_owners/${userId}`, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(UserAction.getUserDetailSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getUserDetailError());
      }
    } catch (e) {
      yield put(UserAction.getUserDetailError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getUserPlatfromOwner(action) {
    const { platformuserId, cb } = action;
    const userId = JSON.parse(localStorage.getItem("platform_owner"))?.[2]?.platform_owner_user
      ?.id;
      const platform_ownerId=JSON.parse(localStorage.getItem("platform_owner"))?.[1]?.platform_owner
      ?.id;
    try {
      let res = yield ApiCaller.Get(
        `platform_owners/${platform_ownerId}/users/${userId}`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(UserAction.getUserPlatfromOwnerSuccess(res.data.data.user));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getUserPlatfromOwnerError());
      }
    } catch (e) {
      yield put(UserAction.getUserPlatfromOwnerError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  // static *getCompanyDetails(action) {
  //   const { userId, cb } = action;
  //   const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
  //     ?.platform_owner?.id;

  //   try {
  //     let res = yield ApiCaller.Get(`rmx_companies/${companyId}`, {
  //       "Content-Type": "application/json",
  //     });

  //     if (res.status == 200) {
  //       yield put(UserAction.getCompanyDetailSuccess(res.data.data));
  //       cb() && cb();
  //       // Functions.showToast(res["data"]["data"]["message"])
  //       // navigate("SignUpVerify", { email })
  //     } else {
  //       yield put(UserAction.getCompanyDetailError());
  //     }
  //   } catch (e) {
  //     yield put(UserAction.getCompanyDetailError(e));
  //     // Functions.showToast(res["data"]["error"]["message"], "danger")
  //     // info("%c{res}", "color: red", " => ", res);
  //   }
  // }

  static *getLocationMiddleWare(action) {
    const { cb } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Get(`rmx_companies/${companyId}/locations`, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(UserAction.getLocationSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getLocationError());
      }
    } catch (e) {
      yield put(UserAction.getLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
  static *getCardsMiddleWare(action) {
    const { cb, params } = action;
    const qureyParams = new URLSearchParams(params).toString();
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/stripe/cards?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getLocationError());
      }
    } catch (e) {
      yield put(UserAction.getLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createLocationMiddleWare(action) {
    const { payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    const signComId = JSON.parse(localStorage.getItem("companyInfo"))?.id;
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${signComId ? signComId : companyId}/locations`,
        { location: [payload] },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        yield put(UserAction.createLocationSuccess(res.data.data[0]));
        cb() && cb();
        info("success", "Plant added successfully");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createLocationError());
      }
    } catch (e) {
      yield put(UserAction.createLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *deleteLocationMiddleWare(action) {
    const { id, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Delete(
        `rmx_companies/${companyId}/locations/${id}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 204) {
        yield put(UserAction.deleteLocationSuccess(id));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.deleteLocationError());
      }
    } catch (e) {
      yield put(UserAction.deleteLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateLocationMiddleWare(action) {
    const { id, cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Put(
        `rmx_companies/${companyId}/locations/${id}`,
        body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.UpdateLocationSuccess(id, res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.UpdateLocationError());
      }
    } catch (e) {
      yield put(UserAction.UpdateLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateAssetsMiddleWare(action) {
    const { id, cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    const payload = {};
    if (body.cover || body.logo) {
      if (body.cover) {
        payload.cover = body.cover;
      }
      if (body.logo) {
        payload.logo = body.logo;
      }
    } else {
      payload.store_name = body.platform_owner_asset.store_name;
      payload.description = body.platform_owner_asset?.description;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    try {
      let res = yield ApiCaller.Put(
        `rmx_companies/${companyId}/assets/${id}`,
        body.cover || body.logo ? formData : payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.updateAssetsSuccess(id, res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        if (body.cover) {
          info("success", "Cover Updated Successfully! ");
          cb() && cb();

          return;
        }
        if (body.logo) {
          info("success", "Logo Updated Successfully! ");
          cb() && cb();

          return;
        }
        if (!body.logo || !body.cover) {
          info("success", "Store Information Updated Successfully! ");
          cb() && cb();

          return;
        }
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateBusinessInfoMiddleare(action) {
    const { id, cb, body } = action;

    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Put(`rmx_companies/${companyId}`, body, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(UserAction.updateBusinessInfoSuccess(id, res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateProfileInfoMiddleare(action) {
    const { id, cb, body, active } = action;
    console.log("active===>", active);
    const userId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    console.log("uuuuuuserId===>", userId);
    const uId = JSON.parse(localStorage.getItem("platform_owner"))?.[2]
      ?.platform_owner_user?.id;
    console.log("uuuuuuserIIIId===>", uId);
    const url = active
      ? `platform_owners/${userId}/users/${
          id ? id : uId
        }/${active.toLowerCase()}`
      : `platform_owners/${userId}/users/${id ? id : uId}`;
    const payload = {};
    if (!body.image?.medium) {
      payload.image = body.image;
      delete body.id;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Put(
        url,
        !!(!body.image?.medium && !body.id) ? formData : body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        if (cb) {
          cb();
        }
        info("success", "Contact information updated successfully!");
        if (active) {
          info("success", "Employee status change successfully!");
        }
        if (body?.image?.name) {
          info("success", "Image Updated Successfully!");
        }

        yield put(UserAction.updateProfileInfoSuccess(id, res.data.data.user));
        yield put(UserAction.getUserSuccess(res.data.data, id));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateProfileInfoError());
      }
    } catch (e) {
      yield put(UserAction.updateProfileInfoError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createAssetsMiddleare(action) {
    const { cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("companyInfo"))?.id;
    const payload = {
      ...body,
    };
    if (body.cover) {
      payload.cover = body.cover;
    }
    if (body.logo) {
      payload.logo = body.logo;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/assets`,
        body.cover || body.logo ? formData : body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        localStorage.setItem("assets", JSON.stringify(res.data.data));
        if (cb) {
          cb();
        }

        yield put(UserAction.createAssetsSuccess(res.data.data.user));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createAssetsError());
      }
    } catch (e) {
      yield put(UserAction.createAssetsError(e));
    }
  }
  static *deleteCardMiddleware(action) {
    const { id, cb, body, cardId } = action;

    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Delete(
        `rmx_companies/${companyId}/stripe/cards/${cardId}`,
        body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsReq());
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *setDefaultCardMiddleware(action) {
    const { id, cb, body, cardId } = action;

    const companyId = JSON.parse(localStorage.getItem("platform_owner"))?.[1]
      ?.platform_owner?.id;
    try {
      let res = yield ApiCaller.Put(
        `rmx_companies/${companyId}/stripe/cards/${cardId}/default`,
        {},
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsReq());
        info("success", "Card set default successfully");
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
  static *verifyZipcodeMiddleware(action) {
    const { cb, payload } = action;

    try {
      let res = yield ApiCaller.Get(
        `verify_zipcode?zipcode=${payload.zipcode}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.verify_zipcode_success());
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.verify_zipcode_error("Incorrect zip code."));
      }
    } catch (e) {
      yield put(UserAction.verify_zipcode_error("Incorrect zip code."));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updatePlatformUserMiddleware(action) {
    const { cb, payload, id } = action;
    const platfromOwnerId = JSON.parse(
      localStorage.getItem("platform_owner")
    )?.[1]?.platform_owner?.id;
    const formData = new FormData();
    if (!payload.id) {
      formData.append("image", payload.image);
    }
    console.log("PAYLOAD==>", payload);

    try {
      let res = yield ApiCaller.Put(
        `platform_owners/${platfromOwnerId}/users/${id}`,
        !payload.id ? formData : payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getUserPlatfromOwnerReq(platfromOwnerId));

        if (!payload.id) {
          info("success", "Image Updated Successfully!");
        } else {
          info("success", "Information Updated Successfully!");
        }

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb();
      } else {
        // yield put(UserAction.verify_zipcode_error("Incorrect zip code."));
      }
    } catch (e) {
      yield put(UserAction.verify_zipcode_error("Incorrect zip code."));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateUserMiddleware(action) {
    const { cb, payload } = action;
    const platfromOwnerId = JSON.parse(
      localStorage.getItem("platform_owner")
    )?.[1]?.platform_owner?.id;

    try {
      let res = yield ApiCaller.Put(
        `platform_owners/${platfromOwnerId}`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getUserDetailReq(platfromOwnerId));
        info("success", "Information Updated Successfully!");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb();
      } else {
        // yield put(UserAction.verify_zipcode_error("Incorrect zip code."));
      }
    } catch (e) {
      yield put(UserAction.verify_zipcode_error("Incorrect zip code."));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
}
